/* My incidents — the page-head lede over the Own-only table (13-15, the shell's language). */

/* The page-head lede (mock .pagehead p). */
.intro {
  margin: 8px 0 28px;
  max-width: 66ch;
  font-size: 15px;
  color: var(--gray);
}
